import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    initialize() {
        super.initialize();

        this.toggle = (event) => this._toggle(event);
    }

    connect() {
        this.invert = this.element.hasAttribute('data-toggle-invert');
        this.invertClasses = this.element.hasAttribute('data-toggle-invert-classes');
        this.toggleTargets = (this.element.dataset.checkboxToggleTargets || '').split(',');
        this.toggleClassesTargets = (this.element.dataset.checkboxToggleClassesTargets || '').split(',');
        this.toggleClasses = (this.element.dataset.checkboxToggleClasses || '').split(',');

        if (this.toggleTargets.length <= 0) {
            console.error('Checkbox toggle trigger does not contain a valid targets');
        } else {
            this.element.addEventListener('input', this.toggle);
            this._toggle(this.element);
        }
    }

    disconnect() {
        this.element.removeEventListener('input', this.toggle);
        super.disconnect();
    }

    _toggle(arg) {
        const input = arg instanceof Event ? arg.currentTarget : arg;
        let show = input.checked;
        let showClasses = show;

        if (input) {
            show = input.checked;
            showClasses = input.checked;
        }

        if (this.invert) {
            show = !show;
        }

        if (this.invertClasses) {
            showClasses = !showClasses;
        }

        this.toggleTargets.forEach(target => {
            document.querySelectorAll(`[data-checkbox-toggle="${target}"]`).forEach(el => {
                if (show) {
                    el.classList.add(...['active']);
                } else {
                    el.classList.remove('active');
                }
            });
        });

        this.toggleClassesTargets.forEach(target => {
            document.querySelectorAll(`[data-checkbox-classes-toggle="${target}"]`).forEach(el => {
                if (showClasses) {
                    el.classList.add(...this.toggleClasses);
                } else {
                    el.classList.remove(this.toggleClasses);
                }
            });
        });
    }
}
